<div class="title-list">
  <h2>Notificaciones enviadas a: {{ user.name }}</h2>
</div>
<div class="container-fluid">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="simple-container">
        <div class="master-container">

          <div class="row no-gutters justify-content-end">
            <div class="col-12 col-lg-9">
              <div class="input-group mb-3 filter-form">
                <input type="text" class="form-control" placeholder="Ingrese un valor para buscar en la tabla de datos ..."
                        [(ngModel)]="searchKey" (keyup)="applyFilter()" autocomplete="off">
                <button mat-button matSuffix mat-icon-button aria-label="Clear" class="clear-bnt" *ngIf="searchKey"
                        (click)="onSearchClear()">
                  <mat-icon>close</mat-icon>
                </button>
                <div class="input-group-append">
                  <button mat-raised-button class="btn btn-info"
                          style="background-color: var(--app-primary-dark); color: white;"
                          type="button" (click)="applyFilter()">
                    <i class="material-icons">find_in_page</i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!--botones para filtrar -->


          <div class="mat-elevation-z8 table-container">
            <mat-table [dataSource]="listNotifications" matSort>

              <ng-container matColumnDef="mensaje">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Mensaje</mat-header-cell>
                <mat-cell *matCellDef="let element">{{element.message}}
                </mat-cell>
              </ng-container>
              <!--mensaje-->

              <ng-container matColumnDef="enviado_el">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Enviado el</mat-header-cell>
                <mat-cell *matCellDef="let element">{{element.created_at | date: 'medium' : 'America/Cancun' : 'en-ES'}}</mat-cell>
              </ng-container>
              <!--enviado_el-->

              <ng-container matColumnDef="leido">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Leído</mat-header-cell>
                <mat-cell *matCellDef="let element">{{(element.read && element.read === 1) ? 'SI' : 'NO'}}</mat-cell>
              </ng-container>
              <!--leido-->

              <ng-container matColumnDef="activo">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Vigente</mat-header-cell>
                <mat-cell *matCellDef="let element">{{(element.active && element.active === 1) ? 'SI' : 'NO'}}</mat-cell>
              </ng-container>
              <!--activo-->


              <ng-container matColumnDef="acciones" style="flex-wrap: wrap !important;">
                <mat-header-cell *matHeaderCellDef>Acciones</mat-header-cell>
                <mat-cell *matCellDef="let row">

                  <button mat-icon-button color="primary" (click)="deleteNotification(row)" matTooltip="Borrar notificación">
                    <mat-icon>delete</mat-icon>
                    <span>Borrar</span>
                  </button>

                </mat-cell>
              </ng-container>
              <!--actions-->


              <ng-container matColumnDef="init">
                <mat-footer-cell *matFooterCellDef colspan="7" style="color: var(--app-primary-dark); font-weight: 400;">
                  Enter a value using the search entry located at the top
                </mat-footer-cell>
              </ng-container>

              <ng-container matColumnDef="noData">
                <mat-footer-cell *matFooterCellDef colspan="7" style="color: #2196F3">
                  No records found
                </mat-footer-cell>
              </ng-container>

              <ng-container matColumnDef="loading">
                <mat-footer-cell *matFooterCellDef colspan="8">
                  <mat-spinner [diameter]="40"></mat-spinner>
                </mat-footer-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="listOfColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: listOfColumns;"></mat-row>

              <mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{hide: spinner === false}"></mat-footer-row>
              <mat-footer-row *matFooterRowDef="['init']" [ngClass]="{'hide':listNotifications!=null || spinner === true}">
              </mat-footer-row>
              <mat-footer-row *matFooterRowDef="['noData']"
                              [ngClass]="{hide:!(listNotifications!=null && listNotifications.data.length==0)}"></mat-footer-row>
            </mat-table>
            <mat-paginator style="overflow: inherit !important;" [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="5"
                            showFirstLastButtons></mat-paginator>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>


